import { render, staticRenderFns } from "./InscricaoTemplate.vue?vue&type=template&id=b20b940e&scoped=true"
import script from "./InscricaoTemplate.vue?vue&type=script&lang=js"
export * from "./InscricaoTemplate.vue?vue&type=script&lang=js"
import style0 from "./InscricaoTemplate.vue?vue&type=style&index=0&id=b20b940e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20b940e",
  null
  
)

export default component.exports